import { useLayoutEffect } from 'react';

import { useGlobalEvent } from '@luna/events';

import { ensureLeadingHashAndSlash, hasLeadingSlash } from './hashUtils';

export const useEnsureLeadingSlash = () => {
    useGlobalEvent('route:change', () => {
        const { location } = window;
        /** RR V6 only supports leading slash hash routes, here we will update the path if there is no leading slash */
        if (!hasLeadingSlash(location.hash)) {
            location.replace(ensureLeadingHashAndSlash(location.hash));
        }
    });
    useLayoutEffect(() => {
        const { location } = window;

        if (!hasLeadingSlash(location.hash)) {
            location.replace(ensureLeadingHashAndSlash(location.hash));
        }
    }, []);
};
